import { render, staticRenderFns } from "./HeadBar.vue?vue&type=template&id=23a6389e&scoped=true"
import script from "./HeadBar.vue?vue&type=script&lang=js"
export * from "./HeadBar.vue?vue&type=script&lang=js"
import style0 from "./HeadBar.vue?vue&type=style&index=0&id=23a6389e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a6389e",
  null
  
)

export default component.exports